export default "__VITE_ASSET__C$t01jrM__"